import React from 'react';
import { connect } from 'react-redux';
import {
  requestClinicLocations,
  requestClientLocations,
} from '../../../store/dashboard/DashboardActions';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';
const { InfoBox } = require('react-google-maps/lib/components/addons/InfoBox');
const { compose, withProps, withStateHandlers } = require('recompose');

class Mapp extends React.Component {
  componentDidMount() {
    this.props.getLocations({ tenantId: this.props.tenantId });
    this.props.getClientLocations({ tenantId: this.props.tenantId });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.dashboard.locations !== this.props.dashboard.locations ||
      nextProps.dashboard.clients !== this.props.dashboard.clients
    );
  }

  render() {
    const StyledMapWithAnInfoBoxForClinicLocations = compose(
      withProps({
        googleMapURL:
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyDFyuIug5lG9d1FjvLLAd6MMjsNnBYKlhU&v=3.exp&libraries=geometry,drawing,places',
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
        center: { lat: 34.500204, lng: -82.586269 },
      }),
      withStateHandlers(
        () => ({
          isOpen: true,
        }),
        {
          onToggleOpen:
            ({ isOpen }) =>
            () => ({
              isOpen: !isOpen,
            }),
        },
      ),
      withScriptjs,
      withGoogleMap,
    )((props) => (
      <GoogleMap defaultZoom={6} defaultCenter={props.center}>
        {this.props.dashboard.locations &&
          this.props.dashboard.locations.map((l, idx) => (
            <Marker
              key={idx}
              position={{
                lat: parseFloat(l.latitude),
                lng: parseFloat(l.longitude),
              }}
              onClick={props.onToggleOpen}
            >
              {props.isOpen && (
                <InfoBox
                  onCloseClick={props.onToggleOpen}
                  options={{ closeBoxURL: ``, enableEventPropagation: true }}
                >
                  <div
                    style={{
                      backgroundColor: `white`,
                      opacity: 0.75,
                      padding: `12px`,
                    }}
                  >
                    <div style={{ fontSize: `16px`, fontColor: `black` }}>
                      <span>{l.siteName}</span>
                    </div>
                  </div>
                </InfoBox>
              )}
            </Marker>
          ))}
      </GoogleMap>
    ));

    const StyledMapWithAnInfoBoxForClientLocations = compose(
      withProps({
        googleMapURL:
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyDFyuIug5lG9d1FjvLLAd6MMjsNnBYKlhU&v=3.exp&libraries=geometry,drawing,places',
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
        center: { lat: 34.500204, lng: -82.586269 },
      }),
      withStateHandlers(
        () => ({
          isOpen: true,
        }),
        {
          onToggleOpen:
            ({ isOpen }) =>
            () => ({
              isOpen: !isOpen,
            }),
        },
      ),
      withScriptjs,
      withGoogleMap,
    )((props) => (
      <GoogleMap defaultZoom={6} defaultCenter={props.center}>
        {this.props.dashboard.clients &&
          this.props.dashboard.clients.map((l, idx) => (
            <Marker
              key={idx}
              position={{
                lat: parseFloat(l.latitude),
                lng: parseFloat(l.longitude),
              }}
              onClick={props.onToggleOpen}
            >
              {props.isOpen && (
                <InfoBox
                  onCloseClick={props.onToggleOpen}
                  options={{ closeBoxURL: ``, enableEventPropagation: true }}
                >
                  <div
                    style={{
                      backgroundColor: `white`,
                      opacity: 0.75,
                      padding: `12px`,
                    }}
                  >
                    <div style={{ fontSize: `16px`, fontColor: `black` }}>
                      <span>{l.siteName}</span>
                    </div>
                  </div>
                </InfoBox>
              )}
            </Marker>
          ))}
      </GoogleMap>
    ));

    return (
      <div>
        <div className="description description-tabs">
          <ul id="myTab" className="nav nav-tabs">
            <li className="active">
              <a href="#clinic" data-toggle="tab" className="no-margin">
                Clinic Locations
              </a>
            </li>
            <li>
              <a href="#client" data-toggle="tab">
                Client Locations
              </a>
            </li>
          </ul>

          <div id="myTabContent" className="tab-content">
            <div className="tab-pane fade active in" id="clinic">
              {this.props.dashboard.locations && (
                <StyledMapWithAnInfoBoxForClinicLocations />
              )}
            </div>
            <div className="tab-pane fade" id="client">
              {this.props.dashboard.clients && (
                <StyledMapWithAnInfoBoxForClientLocations />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    dashboard: state.dashboard,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getLocations: (params) => dispatch(requestClinicLocations(params)),
    getClientLocations: (params) => dispatch(requestClientLocations(params)),
  }),
)(Mapp);



// WEBPACK FOOTER //
// ./src/routes/dashboard/components/Map.js